<template>
    <div>
        <v-select
            :value="value || null"
            :options="options"
            :create-option="normalizeOption"
            :disabled="disabled || loading"
            :loading="loading"
            :selectable="option => Boolean(option)"
            taggable
            select-on-tab
            placeholder="Выберите или введите гражданство"
            @input="$emit('input', normalizeOption($event))"
        >
            <template #search="{attributes, events}">
                <input class="vs__search" v-bind="attributes" v-on="events" maxlength="100" aria-label="Гражданство">
            </template>
            <template #no-options>Введите гражданство и нажмите Enter.</template>
        </v-select>
        <small class="d-block text-muted">Для нового варианта введите название и нажмите Enter.</small>
        <small v-if="loading" class="text-muted">Загрузка гражданств…</small>
        <div v-else-if="error" class="text-danger small mt-1">
            Не удалось загрузить гражданства.
            <b-button variant="link" size="sm" class="p-0" :disabled="disabled" @click="load">
                Повторить
            </b-button>
        </div>
        <small v-else-if="!citizenships.length" class="text-muted">
            Ранее введённых гражданств пока нет.
        </small>
    </div>
</template>

<script>
import api from '@/utils/api';

export default {
    name: 'EmployeeCitizenshipSelect',
    props: {
        value: {type: String, default: ''},
        disabled: {type: Boolean, default: false},
        employeeId: {type: [String, Number], default: null},
        contextParams: {type: Object, default: () => ({})}
    },
    data() {
        return {citizenships: [], loading: false, error: false, requestId: 0};
    },
    computed: {
        options() {
            const values = this.citizenships.slice();
            // Preserve an existing value while loading or if the catalogue changes.
            if (this.value && !values.includes(this.value)) values.push(this.value);
            return values;
        }
    },
    watch: {
        employeeId: 'load',
        contextParams: {handler: 'load', deep: true}
    },
    mounted() {
        this.load();
    },
    beforeDestroy() {
        this.requestId += 1;
    },
    methods: {
        normalizeOption(value) {
            const text = String(value || '').trim().replace(/\s+/g, ' ');
            const key = text.toLocaleLowerCase('ru');
            return this.options.find(option => (
                String(option).trim().replace(/\s+/g, ' ').toLocaleLowerCase('ru') === key
            )) || text;
        },
        async load() {
            const requestId = ++this.requestId;
            this.loading = true;
            this.error = false;
            this.citizenships = [];
            try {
                const response = await api.get('/api/employees/citizenship-options', {
                    params: Object.assign({}, this.contextParams, {employee_id: this.employeeId || undefined}),
                    ignoreModal: true
                });
                if (requestId !== this.requestId) return;
                this.citizenships = response.data && Array.isArray(response.data.citizenships)
                    ? response.data.citizenships : [];
            } catch (error) {
                if (requestId === this.requestId) this.error = true;
            } finally {
                if (requestId === this.requestId) this.loading = false;
            }
        }
    }
};
</script>
